import React from 'react'
import { UserAgentApplication } from "msal"
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { azureConfig } from '../../../azure/azureConfig'
import { clearStoredSession } from '../../../azure/simpleLogin'
import { nullifyUserState } from '../../../redux/userSlice'

export const LogoutButton = ({className = ""}) => {
  const { t } = useTranslation()
  const userAgentApplication = new UserAgentApplication(azureConfig)
  const dispatch = useDispatch()

  const logoutHandler = async () => {
    if (process.env.REACT_APP_SIMPLE_LOGIN === 'true') {
      // There is no tenant session to end. Reloading rebuilds the store empty, which
      // is what msal's logout achieves by navigating away - nullifyUserState alone
      // leaves successToken in place and the user stays signed in.
      clearStoredSession()
      localStorage.clear()
      window.location.assign('/')
      return
    }

    localStorage.clear()
    userAgentApplication.logout()
    dispatch(nullifyUserState)
  }

  return (
    <button className={className} onClick={logoutHandler}>
      {t(`signOut`)}
    </button>
  )
}